import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserCircle, FaSignOutAlt } from 'react-icons/fa';
import { signOut, onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '../services/firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { toast, ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';

import InterestsSettings from '../components/InterestsSettings';

function UserAccountPage() {
  const [userData, setUserData] = useState({
    email: '',
    uid: '',
    yearOfBirth: '',
    displayName: '',
    gender: '',
    interests: [],
  });
  const [newInterest, setNewInterest] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        const data = userDoc.exists() ? userDoc.data() : {};
        setUserData({
          email: user.email,
          uid: user.uid,
          displayName: data.displayName || '',
          yearOfBirth: data.yearOfBirth || '',
          gender: data.gender || '',
          interests: data.interests || [],
        });
      } else {
        navigate('/auth/login');
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/auth/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const validateUserData = () => {
    const missingFields = [];

    if (!userData.yearOfBirth) missingFields.push('Year of birth');
    if (!userData.displayName) missingFields.push('Displayed name');
    if (!userData.gender) missingFields.push('Gender');
    if (!userData.interests || userData.interests.length === 0) missingFields.push('At least one interest');

    if (missingFields.length > 0) {
      toast.error(`Please fill in the required fields: ${missingFields.join(', ')}`);
      return false;
    }

    return true;
  };

  const handleSave = async () => {
    if (!validateUserData()) return;

    setIsSaving(true);
    try {
      await setDoc(doc(db, 'users', userData.uid), {
        ...userData,
      }, { merge: true });

      // Save only displayName to 'user_public' collection
      await setDoc(doc(db, 'users_public', userData.uid), {
        displayName: userData.displayName,
      }, { merge: true });

      navigate('/home');
    } catch (error) {
      console.error('Save error:', error);
      toast.error('Failed to save profile. Please try again.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="container py-5">
      <div className="row align-items-center mb-4">
        <div className="col-2 text-center">
          <FaUserCircle size={40} className="text-primary" />
        </div>
        <div className="col-7">
          <h6 className="mb-0">{userData.email}</h6>
          <small className="text-muted">Logged in</small>
        </div>
        <div className="col-3 text-end">
          <button className="btn btn-outline-danger btn-sm" onClick={handleLogout}>
            <FaSignOutAlt className="me-1" /> Logout
          </button>
        </div>
      </div>

      <hr />
      <InterestsSettings
        userData={userData}
        setUserData={setUserData}
        newInterest={newInterest}
        setNewInterest={setNewInterest}
      />

      <button className="btn btn-success" onClick={handleSave} disabled={isSaving}>
        {isSaving ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Saving...
          </>
        ) : (
          'Save Settings'
        )}
      </button>

      <hr />

      <div className="mt-5">
        <h4 >Contact Us</h4>
        <p>
            If you have any questions or want to report an issue in the application, feel free to
            <Link to="/#contact" className="text-decoration-underline ms-1">
              contact us
            </Link>
          .
        </p>
      </div>


      <ToastContainer position="top-center" autoClose={3000} />

    </div >
  );
}

export default UserAccountPage;
